import React, { useEffect, useState } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import { Api } from "../Api/Api";

export default function AllWorkersBills() {
  const [orders, setOrders] = useState([]);
  const [filteredOrders, setFilteredOrders] = useState([]);
  const [filter, setFilter] = useState("all");
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedDate, setSelectedDate] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const rowsPerPage = 10;

  useEffect(() => {
    fetchOrders();
  }, []);

  useEffect(() => {
    applyFilters();
  }, [orders, filter, searchTerm, selectedDate]);

  const fetchOrders = async () => {
    try {
      const res = await axios.get(`${Api}bills/get_all.php`);
      setOrders(res.data || []);
      console.log(res.data);
    } catch (err) {
      console.error("Error fetching bills:", err);
    }
  };

  // Format YYYY-MM-DD
  const formatDate = (date) => date.toISOString().split("T")[0];

  // Display DD-MM-YYYY
  const displayDate = (dateStr) => {
    const d = new Date(dateStr);
    return d.toLocaleDateString("en-GB");
  };

  const applyFilters = () => {
    let filtered = [...orders];
    const today = new Date();
    const todayStr = formatDate(today);

    if (filter !== "all") {
      let fromDate = new Date();

      if (filter === "today") {
        filtered = filtered.filter(
          (order) => formatDate(new Date(order.created_at)) === todayStr
        );
      } else if (filter === "yesterday") {
        fromDate.setDate(today.getDate() - 1);
        const yesterStr = formatDate(fromDate);
        filtered = filtered.filter(
          (order) => formatDate(new Date(order.created_at)) === yesterStr
        );
      } else if (filter === "lastweek") {
        fromDate.setDate(today.getDate() - 7);
        filtered = filtered.filter(
          (order) =>
            new Date(order.created_at) >= fromDate &&
            new Date(order.created_at) <= today
        );
      } else if (filter === "lastmonth") {
        fromDate.setMonth(today.getMonth() - 1);
        filtered = filtered.filter(
          (order) =>
            new Date(order.created_at) >= fromDate &&
            new Date(order.created_at) <= today
        );
      }
    }

    if (selectedDate) {
      filtered = filtered.filter(
        (order) => formatDate(new Date(order.created_at)) === selectedDate
      );
    }

    if (searchTerm) {
      filtered = filtered.filter(
        (order) =>
          order.invoice_no.includes(searchTerm) ||
          order.worker_name.toLowerCase().includes(searchTerm.toLowerCase())
      );
    }

    setFilteredOrders(filtered);
    setCurrentPage(1);
  };

  // Calculate total of displayed records
  const calculateTotal = () =>
    filteredOrders.reduce((sum, order) => sum + parseFloat(order.paid), 0);

  // Download PDF

  // helper for filename date (DD-MM-YYYY)
  const formatFileDate = (dateStr) => {
    const d = new Date(dateStr);
    const day = String(d.getDate()).padStart(2, "0");
    const month = String(d.getMonth() + 1).padStart(2, "0");
    const year = d.getFullYear();
    return `${day}-${month}-${year}`;
  };

  // const downloadPDF = () => {
  //   if (filteredOrders.length === 0) {
  //     Swal.fire("No Data", "No orders to download", "info");
  //     return;
  //   }

  //   const doc = new jsPDF();
  //   doc.setFontSize(16);
  //   doc.text("Workers Bills Report", 14, 15);

  //   // 🔹 Helper for DD-MM-YYYY format
  //   const formatDateDMY = (date) => {
  //     const d = new Date(date);
  //     const day = String(d.getDate()).padStart(2, "0");
  //     const month = String(d.getMonth() + 1).padStart(2, "0");
  //     const year = d.getFullYear();
  //     return `${day}-${month}-${year}`;
  //   };

  //   // 🔹 Dynamic title info & filename
  //   let filterInfo = "";
  //   let fileName = "workers_bills";
  //   const todayStr = formatDateDMY(new Date());

  //   if (filter === "today") {
  //     filterInfo = `Report for Today (${todayStr})`;
  //     fileName += `_${todayStr}`;
  //   } else if (filter === "yesterday") {
  //     const y = new Date();
  //     y.setDate(y.getDate() - 1);
  //     filterInfo = `Report for Yesterday (${formatDateDMY(y)})`;
  //     fileName += `_${formatDateDMY(y)}`;
  //   } else if (filter === "lastweek") {
  //     filterInfo = "Report for Last Week";
  //     fileName += `_lastweek`;
  //   } else if (filter === "lastmonth") {
  //     filterInfo = "Report for Last Month";
  //     fileName += `_lastmonth`;
  //   } else if (selectedDate) {
  //     filterInfo = `Report for Date: ${formatDateDMY(selectedDate)}`;
  //     fileName += `_${formatDateDMY(selectedDate)}`;
  //   } else if (searchTerm) {
  //     filterInfo = `Report for Search: ${searchTerm}`;
  //     fileName += `_search_${searchTerm.replace(/\s+/g, "_")}`;
  //   } else {
  //     filterInfo = "Report for All Records";
  //     fileName += `_all`;
  //   }

  //   doc.setFontSize(12);
  //   doc.text(filterInfo, 14, 25);

  //   // 🔹 Build table data (without payment_type)
  //   const tableData = [];
  //   let serialNo = 1;

  //   filteredOrders.forEach((order) => {
  //     if (order.items && order.items.length > 0) {
  //       order.items.forEach((item, i) => {
  //         tableData.push([
  //           i === 0 ? serialNo++ : "", // S.NO
  //           i === 0 ? formatDateDMY(order.created_at) : "",
  //           i === 0 ? order.invoice_no : "",
  //           i === 0 ? order.billername : "",
  //           i === 0 ? order.worker_name : "",
  //           item.product,
  //           item.quantity,
  //           `₹${parseFloat(item.price).toFixed(2)}`,
  //           `₹${(item.quantity * item.price).toFixed(2)}`,
  //           i === 0 ? `₹${parseFloat(order.subtotal).toFixed(2)}` : "",
  //           i === 0 ? `₹${parseFloat(order.total).toFixed(2)}` : "",
  //           i === 0 ? `₹${parseFloat(order.paid).toFixed(2)}` : "",
  //         ]);
  //       });
  //     } else {
  //       // no items case
  //       tableData.push([
  //         serialNo++,
  //         formatDateDMY(order.created_at),
  //         order.invoice_no,
  //         order.billername || "-",
  //         order.worker_name,
  //         "No Items",
  //         "-",
  //         "-",
  //         "-",
  //         `₹${parseFloat(order.subtotal).toFixed(2)}`,
  //         `₹${parseFloat(order.total).toFixed(2)}`,
  //         `₹${parseFloat(order.paid).toFixed(2)}`,
  //       ]);
  //     }
  //   });

  //   autoTable(doc, {
  //     head: [
  //       [
  //         "S.NO",
  //         "Date",
  //         "Invoice No",
  //         "Biller Name",
  //         "Worker Name",
  //         "Product",
  //         "Qty",
  //         "Price",
  //         "Item Total",
  //         "Subtotal",
  //         "Total",
  //         "Paid",
  //       ],
  //     ],
  //     body: tableData,
  //     startY: 35,
  //     styles: { lineWidth: 0.2, lineColor: [0, 0, 0], textColor: [0, 0, 0] },
  //     headStyles: { fillColor: [255, 255, 255], textColor: [0, 0, 0] },
  //     theme: "grid",
  //   });

  //   // 🔹 Show grand total
  //   const totalAmount = calculateTotal().toFixed(2);
  //   const pageWidth = doc.internal.pageSize.getWidth();
  //   const totalText = `Total Paid: ₹${totalAmount}`;
  //   const textWidth = doc.getTextWidth(totalText);
  //   doc.setFontSize(12);
  //   doc.text(
  //     totalText,
  //     pageWidth - textWidth - 14,
  //     doc.lastAutoTable.finalY + 10
  //   );

  //   // 🔹 Save PDF
  //   doc.save(`${fileName}.pdf`);
  // };

  const downloadPDF = () => {
    if (filteredOrders.length === 0) {
      Swal.fire("No Data", "No orders to download", "info");
      return;
    }

    const doc = new jsPDF();
    doc.setFontSize(16);
    doc.text("Workers Bills Report", 14, 15);

    const formatDateDMY = (date) => {
      const d = new Date(date);
      const day = String(d.getDate()).padStart(2, "0");
      const month = String(d.getMonth() + 1).padStart(2, "0");
      const year = d.getFullYear();
      return `${day}-${month}-${year}`;
    };

    let filterInfo = "Report for All Records";
    if (filter !== "all") filterInfo = `Report for ${filter}`;
    if (selectedDate)
      filterInfo = `Report for Date: ${formatDateDMY(selectedDate)}`;
    if (searchTerm) filterInfo = `Report for Search: ${searchTerm}`;

    doc.setFontSize(12);
    doc.text(filterInfo, 14, 25);

    const tableData = [];
    let serialNo = 1;

    filteredOrders.forEach((order) => {
      if (order.items && order.items.length > 0) {
        order.items.forEach((item, i) => {
          tableData.push([
            i === 0 ? serialNo++ : "", // S.NO
            i === 0 ? formatDateDMY(order.created_at) : "",
            i === 0 ? order.invoice_no : "",
            i === 0 ? order.billername || "-" : "",
            i === 0 ? order.worker_name : "",
            item.product,
            item.quantity,
            parseFloat(item.price).toFixed(2),
            (item.quantity * item.price).toFixed(2),
            i === 0 ? parseFloat(order.subtotal).toFixed(2) : "",
            i === 0 ? parseFloat(order.total).toFixed(2) : "",
            i === 0 ? parseFloat(order.paid).toFixed(2) : "",
          ]);
        });
      } else {
        tableData.push([
          serialNo++,
          formatDateDMY(order.created_at),
          order.invoice_no,
          order.billername || "-",
          order.worker_name,
          "No Items",
          "-",
          "-",
          "-",
          parseFloat(order.subtotal).toFixed(2),
          parseFloat(order.total).toFixed(2),
          parseFloat(order.paid).toFixed(2),
        ]);
      }
    });

    autoTable(doc, {
      head: [
        [
          "S.NO",
          "Date",
          "Invoice No",
          "Biller Name",
          "Worker Name",
          "Product",
          "Qty",
          "Price",
          "Item Total",
          "Subtotal",
          "Total",
          "Paid",
        ],
      ],
      body: tableData,
      startY: 35,
      styles: { lineWidth: 0.2, lineColor: [0, 0, 0], halign: "right" },
      headStyles: { fillColor: [200, 200, 200], textColor: [0, 0, 0] },
      columnStyles: {
        0: { halign: "center" }, // S.NO
        1: { halign: "center" }, // Date
        2: { halign: "center" }, // Invoice
        5: { halign: "left" }, // Product
        6: { halign: "center" }, // Qty
        7: { halign: "right" }, // Price
        8: { halign: "right" }, // Item Total
        9: { halign: "right" }, // Subtotal
        10: { halign: "right" }, // Total
        11: { halign: "right" }, // Paid
      },
      theme: "grid",
    });

    // Grand total without ₹
    const totalAmount = calculateTotal().toFixed(2);
    const pageWidth = doc.internal.pageSize.getWidth();
    const rightMargin = 14; // margin from right edge
    const totalText = `Total Paid: ${totalAmount}`;
    const textWidth = doc.getTextWidth(totalText);
    doc.setFontSize(12);
    doc.text(
      totalText,
      pageWidth - textWidth - rightMargin,
      doc.lastAutoTable.finalY + 10
    );

    doc.save("workers_bills.pdf");
  };

  const indexOfLast = currentPage * rowsPerPage;
  const indexOfFirst = indexOfLast - rowsPerPage;
  const currentOrders = filteredOrders.slice(indexOfFirst, indexOfLast);
  const totalPages = Math.ceil(filteredOrders.length / rowsPerPage);

  return (
    <div className="p-4">
      {/* Filters */}
      <div className="flex flex-wrap gap-2 mb-4 items-center">
        <select
          value={filter}
          onChange={(e) => setFilter(e.target.value)}
          className="border p-2 rounded text-sm"
        >
          <option value="all">All</option>
          <option value="today">Today</option>
          <option value="yesterday">Yesterday</option>
          <option value="lastweek">Last Week</option>
          <option value="lastmonth">Last Month</option>
        </select>

        <input
          type="date"
          value={selectedDate}
          onChange={(e) => setSelectedDate(e.target.value)}
          className="border p-2 rounded text-sm"
        />

        <input
          type="text"
          placeholder="Search Invoice or Worker"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          className="border p-2 rounded text-sm flex-1 min-w-[200px]"
        />

        <button
          onClick={downloadPDF}
          className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700"
        >
          Download PDF
        </button>
      </div>

      {/* Total */}
      <h6 className="text-right mb-2 font-semibold">
        Total: ₹{calculateTotal().toFixed(2)}
      </h6>

      {/* Table */}
      <div className="overflow-x-auto border rounded shadow max-h-[70vh]">
        <table className="min-w-full border-collapse text-sm">
          <thead className="bg-gray-800 text-white sticky top-0">
            <tr>
              <th className="px-3 py-2 border">S.NO</th>
              <th className="px-3 py-2 border">Date</th>
              <th className="px-3 py-2 border">Invoice No</th>
              <th className="px-3 py-2 border">Billler Name</th>

              <th className="px-3 py-2 border">Worker Name</th>
              <th className="px-3 py-2 border">Payment Type</th>
              <th className="px-3 py-2 border">Item Product</th>
              <th className="px-3 py-2 border">Item Quantity</th>
              <th className="px-3 py-2 border">Item Price</th>
              <th className="px-3 py-2 border">Subtotal</th>
              <th className="px-3 py-2 border">Total</th>
              <th className="px-3 py-2 border">Paid</th>
            </tr>
          </thead>
          <tbody>
            {currentOrders.length > 0 ? (
              currentOrders.map((order, idx) =>
                order.items && order.items.length > 0 ? (
                  order.items.map((item, i) => (
                    <tr
                      key={`${order.id}-${i}`}
                      className="odd:bg-gray-100 hover:bg-gray-50"
                    >
                      {/* Show order details only for first item row */}
                      {i === 0 && (
                        <>
                          <td
                            className="px-3 py-2 border"
                            rowSpan={order.items.length}
                          >
                            {indexOfFirst + idx + 1}
                          </td>
                          <td
                            className="px-3 py-2 border"
                            rowSpan={order.items.length}
                          >
                            {displayDate(order.created_at)}
                          </td>
                          <td
                            className="px-3 py-2 border"
                            rowSpan={order.items.length}
                          >
                            {order.invoice_no}
                          </td>
                          <td
                            className="px-3 py-2 border"
                            rowSpan={order.items.length}
                          >
                            {order.billername}
                          </td>
                          <td
                            className="px-3 py-2 border"
                            rowSpan={order.items.length}
                          >
                            {order.worker_name}
                          </td>
                          <td
                            className="px-3 py-2 border"
                            rowSpan={order.items.length}
                          >
                            {order.payment_type}
                          </td>
                        </>
                      )}

                      {/* Item columns */}
                      <td className="px-3 py-2 border">{item.product}</td>
                      <td className="px-3 py-2 border">{item.quantity}</td>
                      <td className="px-3 py-2 border">₹{item.price}</td>

                      {/* Subtotal/Total/Paid only once, aligned with last row of the order */}
                      {i === 0 && (
                        <>
                          <td
                            className="px-3 py-2 border"
                            rowSpan={order.items.length}
                          >
                            ₹{order.subtotal}
                          </td>
                          <td
                            className="px-3 py-2 border"
                            rowSpan={order.items.length}
                          >
                            ₹{order.total}
                          </td>
                          <td
                            className="px-3 py-2 border"
                            rowSpan={order.items.length}
                          >
                            ₹{order.paid}
                          </td>
                        </>
                      )}
                    </tr>
                  ))
                ) : (
                  // If no items exist
                  <tr
                    key={order.id}
                    className="odd:bg-gray-100 hover:bg-gray-50"
                  >
                    <td className="px-3 py-2 border">
                      {indexOfFirst + idx + 1}
                    </td>
                    <td className="px-3 py-2 border">
                      {displayDate(order.created_at)}
                    </td>
                    <td className="px-3 py-2 border">{order.invoice_no}</td>
                    <td className="px-3 py-2 border">{order.worker_name}</td>
                    <td className="px-3 py-2 border">{order.payment_type}</td>
                    <td className="px-3 py-2 border" colSpan="3" align="center">
                      No Items
                    </td>
                    <td className="px-3 py-2 border">₹{order.subtotal}</td>
                    <td className="px-3 py-2 border">₹{order.total}</td>
                    <td className="px-3 py-2 border">₹{order.paid}</td>
                  </tr>
                )
              )
            ) : (
              <tr>
                <td colSpan="11" className="text-center py-3">
                  No records found
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {/* Pagination */}
      {totalPages > 1 && (
        <div className="flex justify-center mt-4 gap-2 items-center">
          <button
            className="px-3 py-1 border rounded bg-gray-200 disabled:opacity-50"
            disabled={currentPage === 1}
            onClick={() => setCurrentPage(currentPage - 1)}
          >
            Prev
          </button>
          <span className="text-sm">
            Page {currentPage} of {totalPages}
          </span>
          <button
            className="px-3 py-1 border rounded bg-gray-200 disabled:opacity-50"
            disabled={currentPage === totalPages}
            onClick={() => setCurrentPage(currentPage + 1)}
          >
            Next
          </button>
        </div>
      )}
    </div>
  );
}
